import React from 'react'
import DOMPurify from 'dompurify'
import styles from './footnote.module.scss'

const Footnote = ({ content }) => (
  <div className={styles.footnote} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
)

export default Footnote
